import React, { Suspense } from "react";
import { connect } from "react-redux";
import { LayoutSplashScreen } from "../../../_metronic";
import EmailNaoVerificadoAlert from "../../components/EmailNaoVerificadoAlert";
import LocalizacaoPendenteAlert from "../../components/localizacao/LocalizacaoPendenteAlert";
import TransportadorRoutes from "./transportadora/TransportadorRoutes";
import EmbarcadoraRoutes from "./embarcadora/EmbarcadoraRoutes";
import UsinaRoutes from "./usina/UsinaRoutes";

function HomeRoutes(props) {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <EmailNaoVerificadoAlert />
      <LocalizacaoPendenteAlert />

      {props.user.token_type === "transportadora" ? (
        <TransportadorRoutes user={props.user} />
      ) : props.user.token_type === "embarcadora" ? (
        <EmbarcadoraRoutes />
      ) : (
        <UsinaRoutes />
      )}
    </Suspense>
  );
}

const mapStateToProps = ({ auth: { user } }) => ({ user });

export default connect(mapStateToProps)(HomeRoutes);
